import React from "react";
import "./PrivacyPolicy.css";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-container">
      <div className="privacy-header">
        <h1>Privacy Policy for Satta Wala</h1>
        <p>At Satta Wala, protecting your privacy is our top priority.</p>
      </div>

      <div className="privacy-content">
        <section>
          <p>
            At <strong>Satta Wala</strong>, accessible from{" "}
            <a href="https://sattawalaonline.com/" target="_blank" rel="noopener noreferrer">
              https://sattawalaonline.com/
            </a>, one of our main priorities is the privacy of our visitors.
            This Privacy Policy document contains types of information that is collected
            and recorded by <strong>Satta Wala</strong> and how we use it.
          </p>
          <p>
            If you have additional questions or require more information about our
            Privacy Policy, do not hesitate to contact us.
          </p>
          <p>
            This Privacy Policy applies only to our online activities and is valid for
            visitors to our website with regards to the information that they shared
            and/or collect in <strong>Satta Wala</strong>. This policy is not applicable
            to any information collected offline or via channels other than this website.
          </p>
        </section>

        <section>
          <h2>Consent</h2>
          <p>
            By using our website, you hereby consent to our Privacy Policy and agree to
            its terms.
          </p>
        </section>

        <section>
          <h2>Information We Collect</h2>
          <p>
            The personal information that you are asked to provide, and the reasons why
            you are asked to provide it, will be made clear to you at the point we ask
            you to provide your personal information.
          </p>
          <p>
            If you contact us directly, we may receive additional information about you
            such as your name, email address, phone number, the contents of the message
            and/or attachments you may send us, and any other information you may choose
            to provide.
          </p>
          <p>
            When you register for an account, we may ask for your contact information,
            including items such as name, company name, address, email address, and
            telephone number.
          </p>
        </section>

        <section>
          <h2>How We Use Your Information</h2>
          <ul>
            <li>Provide, operate, and maintain our website</li>
            <li>Improve, personalize, and expand our website</li>
            <li>Understand and analyze how you use our website</li>
            <li>Develop new products, services, features, and functionality</li>
            <li>
              Communicate with you, either directly or through our partners, for
              customer service, updates, and promotional purposes
            </li>
            <li>Send you emails</li>
            <li>Find and prevent fraud</li>
          </ul>
        </section>

        <section>
          <h2>Log Files</h2>
          <p>
            <strong>Satta Wala</strong> follows a standard procedure of using log files.
            These files log visitors when they visit websites. All hosting companies do
            this as part of hosting services' analytics. The information collected by log
            files include internet protocol (IP) addresses, browser type, Internet
            Service Provider (ISP), date and time stamp, referring/exit pages, and
            possibly the number of clicks. These are not linked to any information that
            is personally identifiable. The purpose of the information is for analyzing
            trends, administering the site, tracking users' movement on the website, and
            gathering demographic information.
          </p>
        </section>

        <section>
          <h2>Cookies and Web Beacons</h2>
          <p>
            Like any other website, <strong>Satta Wala</strong> uses "cookies". These
            cookies are used to store information including visitors' preferences, and
            the pages on the website that the visitor accessed or visited. The
            information is used to optimize the users' experience by customizing our web
            page content based on visitors' browser type and/or other information.
          </p>
        </section>

        <section>
          <h2>Google DoubleClick DART Cookie</h2>
          <p>
            Google is one of a third-party vendor on our site. It also uses cookies,
            known as DART cookies, to serve ads to our site visitors based upon their
            visit to our website and other sites on the internet. However, visitors may
            choose to decline the use of DART cookies by visiting the Google ad and
            content network Privacy Policy at{" "}
            <a
              href="https://policies.google.com/technologies/ads"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://policies.google.com/technologies/ads
            </a>
            .
          </p>
        </section>

        <section>
          <h2>Advertising Partners Privacy Policies</h2>
          <p>
            You may consult this list to find the Privacy Policy for each of the
            advertising partners of <strong>Satta Wala</strong>. Third-party ad servers
            or networks use technologies like cookies, JavaScript, or Web Beacons in
            their respective advertisements and links that appear on our website. They
            automatically receive your IP address when this occurs. These technologies
            are used to measure the effectiveness of their advertising campaigns and/or
            to personalize the advertising content that you see on websites that you
            visit.
          </p>
          <p>
            Note that <strong>Satta Wala</strong> has no access to or control over these
            cookies that are used by third-party advertisers.
          </p>
        </section>

        <section>
          <h2>Third Party Privacy Policies</h2>
          <p>
            <strong>Satta Wala</strong>'s Privacy Policy does not apply to other
            advertisers or websites. We advise you to consult the respective Privacy
            Policies of these third-party ad servers for more detailed information. It
            may include their practices and instructions about how to opt-out of certain
            options.
          </p>
          <p>
            You can choose to disable cookies through your browser options. More
            detailed information about cookie management can be found at the browsers'
            respective websites.
          </p>
        </section>

        <section>
          <h2>CCPA Privacy Rights (Do Not Sell My Personal Information)</h2>
          <p>
            Under the CCPA, California consumers have the right to request that a
            business disclose categories of personal data collected, delete any personal
            data collected, and request that a business that sells personal data not
            sell their personal data. If you make a request, we have one month to
            respond. To exercise these rights, please contact us.
          </p>
        </section>

        <section>
          <h2>GDPR Data Protection Rights</h2>
          <p>Every user is entitled to the following rights:</p>
          <ul>
            <li>The right to access – request copies of your personal data</li>
            <li>The right to rectification – request correction of inaccurate info</li>
            <li>The right to erasure – request deletion of your data</li>
            <li>The right to restrict processing – under certain conditions</li>
            <li>The right to object to processing – under certain conditions</li>
            <li>The right to data portability – request data transfer</li>
          </ul>
          <p>
            If you make a request, we have one month to respond. To exercise these
            rights, please contact us.
          </p>
        </section>

        <section>
          <h2>Children's Information</h2>
          <p>
            Protecting children’s privacy is important to us. <strong>Satta Wala</strong>{" "}
            does not knowingly collect any Personal Identifiable Information from
            children under the age of 13. If you think your child provided such
            information, please contact us immediately, and we will do our best efforts
            to promptly remove such information from our records.
          </p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
